import React, { useEffect, useState } from 'react';
import { Row, Col, Button } from "react-bootstrap";
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { ToastContainer, toast } from "react-toastify";
import { configData } from '../config/systemconfigurationconstants';
import * as AWS from 'aws-sdk';
import lambdaConfig from "../hooks/lambdaConfig";
import UseLambdaInvocations from "../hooks/useLambdaInvocations";

let defaultUseCase = '';
let defaultCient = '';
let defaultRole = '';
const SwitchAccount = ({ show, handleClose, usermappingDetails, getRolesAndRights }) => {

    const [getmappingDetails, setGetMappingDetails] = useState([]);
    const [filterClientList, setFilterClientList] = useState([]);
    const [filterUsecaseID, setFilterUsecaseID] = useState();
    const [filterClientID, setFilterClientId] = useState();
    const [filterRoleList, setFilterRoleList] = useState([]);
    const [filterRoleID, setFilterRoleID] = useState();
    const [tosterData, setTosterData] = useState([]);
    const lambda = new AWS.Lambda({
        region: configData.LAMBDA_REGION,
        accessKeyId: configData.BASE_ACCESS_KEY_ID,
        secretAccessKey: configData.BASE_SECRET_ACCESS_KEY
    });
    const { invokeLambda } = UseLambdaInvocations();

    useEffect(() => {
        console.log(usermappingDetails)
        if (usermappingDetails) {
            const uniqueObjectsMap = Array.from(
                usermappingDetails?.reduce((map, obj) => map.set(obj.UseCaseName, obj), new Map()).values()
            );
            setGetMappingDetails(uniqueObjectsMap)
            let getisDefultUserMapId = usermappingDetails.filter(x => x.UserMapId === Number(localStorage.getItem("mappingIDForUser")))
            setFilterUsecaseID(getisDefultUserMapId[0].UseCaseId);
            setFilterClientId(getisDefultUserMapId[0].ClientId);
            setFilterRoleID(getisDefultUserMapId[0].RoleMasterId);
            mappingUsecaseChange(getisDefultUserMapId[0].UseCaseId);
            mappingClientChange(getisDefultUserMapId[0].ClientId);
            mappingRoleChange(getisDefultUserMapId[0].RoleMasterId);
            defaultUseCase = getisDefultUserMapId[0].UseCaseId;
            defaultCient = getisDefultUserMapId[0].ClientId;
            defaultRole = getisDefultUserMapId[0].RoleMasterId;
        }
    }, [])
    useEffect(() => {
        console.log("value updated")
    }, [filterUsecaseID, filterClientID, filterRoleID])
    const mappingUsecaseChange = (usecasevalue) => {
        let getselectedUseCaseValue = usecasevalue
        console.log(usermappingDetails.filter(x => Number(x.UseCaseId) === Number(getselectedUseCaseValue)),"usecasevalue")
        setFilterUsecaseID(usecasevalue)
        defaultUseCase = usecasevalue;
        let getFilteredClientName = usermappingDetails.filter(x => Number(x.UseCaseId) === Number(getselectedUseCaseValue));
        localStorage.setItem("UseCaseShortName", getFilteredClientName[0].UCSN);
        console.log(getFilteredClientName)
        let FilterUniqueclientList = Array.from(
            getFilteredClientName?.reduce((map, obj) => map.set(obj.ClientId, obj), new Map()).values()
        );
        setFilterClientList(FilterUniqueclientList)
    }
    const mappingClientChange = (clientvalue) => {
        const getselectedClientList = clientvalue;
        setFilterClientId(clientvalue)
        defaultCient = clientvalue;
        let getFilteredClientName = usermappingDetails.filter(x => Number(x.ClientId) === Number(getselectedClientList));
        localStorage.setItem("ClientShortName", getFilteredClientName[0].CSN);
        let FilterUniqueRoleList = Array.from(
            getFilteredClientName?.reduce((map, obj) => map.set(obj.RoleMasterId, obj), new Map()).values()
        );
        setFilterRoleList(FilterUniqueRoleList)
    }
    const mappingRoleChange = (rolevalue) => {
        let getSelectedRolemapId = rolevalue
        setFilterRoleID(rolevalue)
        defaultRole = rolevalue;
        let getFilterRoleMapID = usermappingDetails.filter(x => Number(x.ClientId) === Number(defaultCient) && Number(x.UseCaseId) === Number(defaultUseCase) && Number(x.RoleMasterId) === Number(getSelectedRolemapId));
        console.log(getFilterRoleMapID)
        let getSelectedUserRoleMappingID = getFilterRoleMapID[0].UserMapId;
        localStorage.setItem("mappingIDForUser", getSelectedUserRoleMappingID)
        localStorage.setItem("Role", getFilterRoleMapID[0].RoleName);
        setTosterData(getFilterRoleMapID)
    }
    const callSwitchAccount = () => {
        getRolesAndRights();
        getManageRolesAndRights();
        handleClose();
        toast.success("Data is configured to " + tosterData[0].UseCaseName + " and " + tosterData[0].ClientName, {
            position: "bottom-center",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const getManageRolesAndRights = async () => {
        console.log("works");
        try {
            const payload = {
                ...lambdaConfig,
                SecurityToken: localStorage.getItem('SecurityToken'),
            };

            const parsedBody = await invokeLambda(configData.GET_MANAGE_ROLES_RIGHTS, payload);
            let role = localStorage.getItem("Role");
            if (parsedBody.Status) {
                console.log("getManageRolesAndRights() - parsedBody.RolesAndRights", parsedBody);
                localStorage.setItem("RolesAndRights", JSON.stringify(parsedBody));
                localStorage.setItem("UserRights", JSON.stringify(parsedBody.RolesAndRights.find(el => el.RoleName == role).Rights));
            } else {
                // 
            }
        } catch (err) {
            console.error("Lambda error:", err);
        }
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Switch Account</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Row>
                        <Col sm={4} className='pe-0'>
                            <Form.Group className="mb-2">
                                <Form.Label>Usecase</Form.Label>
                                <Form.Select aria-label="Usecase" size='sm' value={filterUsecaseID} onChange={(event) => mappingUsecaseChange(event.target.value)}>
                                    <option value="" disabled>--Select Usecase --</option>
                                    {getmappingDetails.length !== 0 && getmappingDetails?.map((el) => (
                                        <option value={el.UseCaseId}>{el.UseCaseName}</option>
                                    ))}

                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col sm={4} className='pe-0'>
                            <Form.Group className="mb-2">
                                <Form.Label>Client</Form.Label>
                                <Form.Select aria-label="Usecase" size='sm' value={filterClientID} onChange={(event) => mappingClientChange(event.target.value)}>
                                    <option disabled value="">--Select Client --</option>
                                    {filterClientList.length !== 0 && filterClientList?.map((el) => (
                                        <option value={el.ClientId}>{el.ClientName}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col sm={4} className='pe-0'>
                            <Form.Group className="mb-2">
                                <Form.Label>User Role</Form.Label>
                                <Form.Select aria-label="Usecase" size='sm' value={filterRoleID} onChange={(event) => mappingRoleChange(event.target.value)}>
                                    <option disabled>--Select UserRole --</option>
                                    {filterRoleList.length !== 0 && filterRoleList?.map((el) => (
                                        <option value={el.RoleMasterId}>{el.RoleName}</option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>

                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" size='sm' onClick={handleClose}>
                    Cancel
                </Button>
                <Button variant="primary" size='sm' onClick={callSwitchAccount}>
                    Switch Account
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default SwitchAccount;